import { DataBean } from "../DataBean";

export class AuxiliaryBrand extends DataBean {



    public async getAuxiliaryBrandListForFixedAssetLine(idLine: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAuxiliaryBrandListForFixedAssetLine_Number", [idLine]);
    }

}